import React from 'react';
import RMSCommonDialog from '../../shared/components/dialog/RMSCommonDialog';
import ManageSignaturePage from '../pages/ManageSignaturePage';

const ManageSignatureDialog = ({ close }) => (
  <RMSCommonDialog
    open
    title="Manage Signature"
    onClose={close}
    maxWidth="sm"
    fullWidth
    closeOnBackdropClick={false}
    saveButton={{ show: false }}
    cancelButton={{ show: false }}
    dialogClassName="manage-signature-dialog">
    <ManageSignaturePage />
  </RMSCommonDialog>
);

export default ManageSignatureDialog;
